// extracted by mini-css-extract-plugin
export default {"banner":"offline-banner_banner__KPrqi","dot":"offline-banner_dot__+gG+Q","pulse":"offline-banner_pulse__DRalU"};